import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown, FaBars, FaTimes, FaLinkedin } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Reload the page if the user is already on the home page and clicks the logo
  const handleLogoClick = () => {
    if (isHomePage) {
      // Force a full page refresh
      window.location.reload();
    }
  };
  const [menuOpen, setMenuOpen] = useState(false);
  const [, setOpenDropdown] = useState(null);

  const handleDropdownClick = (key, e) => {
    if (window.innerWidth <= 1024) {
      e.preventDefault();
      setOpenDropdown(prev => (prev === key ? null : key));
    }
  };
  return (
    <header className={`header ${isHomePage ? 'home' : 'not-home'}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/" className="logo-link" onClick={handleLogoClick}>ICES2026</Link>
        </div>
        <button className="mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
        <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          <div className="nav-item dropdown">
            <Link to="/speakers/plenary" className="nav-link" onClick={(e)=>handleDropdownClick('speakers',e)}>Speakers <FaChevronDown className="chevron-down"/></Link>
            <div className="dropdown-menu">
              <Link to="/speakers/plenary" className="dropdown-link">Plenary Speakers</Link>
              <Link to="/speakers/keynote" className="dropdown-link">Keynote Speakers</Link>
              <Link to="/speakers/eic-forum" className="dropdown-link">Editors-in-Chief's Forum</Link>
            </div>
          </div>
          <div className="nav-item dropdown">
            <Link to="/committees/co-chairs" className="nav-link" onClick={(e)=>handleDropdownClick('committees',e)}>Committees <FaChevronDown className="chevron-down"/></Link>
            <div className="dropdown-menu">
              <Link to="/committees/co-chairs" className="dropdown-link">Co-Chairs</Link>
              <Link to="/committees/local-organizing" className="dropdown-link">Local Organizing Committee</Link>
              {/* <Link to="/committees/international-organizing" className="dropdown-link">International Organizing Committee</Link> */}
              <Link to="/committees/international-advisory" className="dropdown-link">International Advisory Committee</Link>
              <Link to="/committees/international-scientific" className="dropdown-link">International Scientific Committee</Link>
              <Link to="/committees/international-ecr" className="dropdown-link">International ECR Committee</Link>
            </div>
          </div>
          <div className="nav-item dropdown">
            <Link to="/travel/info" className="nav-link" onClick={(e)=>handleDropdownClick('travel',e)}>Travel <FaChevronDown className="chevron-down"/></Link>
            <div className="dropdown-menu">
              <Link to="/travel/info" className="dropdown-link">Travel Info</Link>
              <Link to="/travel/accommodation" className="dropdown-link">Accommodation</Link>
            </div>
          </div>
          <Link to="/venue" className="nav-link">Venue</Link>
          <Link to="/registration" className="nav-link">Registration</Link>
          <div className="nav-item dropdown">
            <Link to="/information/templates" className="nav-link" onClick={(e)=>handleDropdownClick('information',e)}>Information <FaChevronDown className="chevron-down"/></Link>
            <div className="dropdown-menu">
              <Link to="/information/program" className="dropdown-link">Program</Link>
              <Link to="/information/templates" className="dropdown-link">Templates</Link>
              <Link to="/information/ms-ss-registration" className="dropdown-link">MS/SS Registration</Link>
              <Link to="/information/prize" className="dropdown-link">Medal &amp; Prize Nominations</Link>
              <Link to="/information/best-paper" className="dropdown-link">Best Paper Awards</Link>
            </div>
          </div>
          <a
            href="https://www.linkedin.com/company/ices2026/"
            target="_blank"
            rel="noopener noreferrer"
            className="header-social-link"
            aria-label="ICES2026 on LinkedIn"
          >
            <FaLinkedin className="header-social-icon" />
            <span className="header-social-label">LinkedIn</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
